module.exports = __webpack_public_path__ + "img/payment-failed-illustration.30ae0303.svg";